import React from 'react';
import styled from 'styled-components';
import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Popup from 'reactjs-popup';
import PopupTable from '../../PopupTable';
import * as XLSX from 'xlsx';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import { useGetAssetsFinalQuery } from '../../../features/addassets/addassetfinalApiSlice';
import { useEditAssettagsMutation,  useGetAssetsQuery } from '../../../features/addassets/addassetApiSlice';


const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
`
const HeadingWrap2 =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:10px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #5C5891;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const SelectFileReset = styled.button`
  margin-right: 10px;
`
const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const checkDuplicates = (data, key) => {
  const seen = new Set();
  const duplicates = new Set();

  data.forEach((row) => {
    if (row[key]) {
      const value = row[key];
      if (seen.has(value)) {
        duplicates.add(value);
      } else {
        seen.add(value);
      }
    }
  });

  return duplicates;
};



const OrgToOem = () => {

  const inputFile = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tabledata, setTabledata]= useState([]);  
  
  
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const { allassets } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      allassets: data?.entities
    }),
  })
  const { addassets } = useGetAssetsQuery('addassets', {
    selectFromResult: ({ data }) => ({
      addassets: data?.entities
    }),
  })

  const [editAssetTags, { isLoading }] = useEditAssettagsMutation();
  


  const handleButtonClick = () => {
    inputFile.current.click();
  };
  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
    }
  }

  const onBulkSubmit = (e) =>{
    e.preventDefault();
    if(!file?.length){
      return alert("Please Upload file before confirming");
    }
    setTabledata(file);
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]

  const handleChangeOemTags = async (e) => {
    const selectedFile = e.target.files[0];
  
    if (!selectedFile) {
      setFileError("No file selected");
      setFile(null);
      return;
    }
  
    if (!fileType.includes(selectedFile.type)) {
      setFileError("Please select a valid file type");
      setFile(null);
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = (e) => {
      try {
        setFileError(null);
        const workbook = XLSX.read(e.target.result, { type: 'buffer' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        let data = XLSX.utils.sheet_to_json(worksheet);
  
        // Preprocess data: Trim spaces from all cell values
        data = data.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [key, typeof value === "string" ? value.trim() : value])
          )
        );
  
        // Check for duplicates in "oem_tag" and "org_tag"
        const oemTagDuplicates = checkDuplicates(data, "oem_tag");
        const orgTagDuplicates = checkDuplicates(data, "org_tag");
  
        if (oemTagDuplicates.size || orgTagDuplicates.size) {
          inputFile.current.value = null; // Clear the file input
          alert(
            `Duplicate values found: \n` +
            `OEM_Tags: ${oemTagDuplicates.size ? [...oemTagDuplicates].join(", ") : "None"}\n` +
            `ORG_Tags: ${orgTagDuplicates.size ? [...orgTagDuplicates].join(", ") : "None"}`
          );
          return;
        }  
        setFileName(selectedFile.name);
        setFile(data);
      } catch (error) {
        console.error("Error processing file:", error);
        setFileError("An error occurred while processing the file");
        setFile(null);
      }
    };  
    reader.onerror = () => {
      setFileError("An error occurred while reading the file");
      setFile(null);
    };
  
    reader.readAsArrayBuffer(selectedFile);
  };
  
  
  const onConfirmFinal = async () => {
    const body = {"type":"orgtooem", "data":tabledata};
    const result = await editAssetTags(body);
    console.log(result.data.message);
    alert(result.data.message);
  }
console.log(tabledata)
  return (
    <>
    <HeadingWrap>
      <Span>Edit OEM Tags (ORG tags Known)</Span>
    </HeadingWrap>

    <HeadingWrap2>
      <HeadingField>Upload File</HeadingField>
    </HeadingWrap2>
   <form onSubmit={onBulkSubmit}>

    <BulkWrapper>
      <InputFile type="file" onChange={handleChangeOemTags} ref={inputFile} />
      <CustomFileUploadButton htmlFor="file-upload" onClick={handleButtonClick}>
        Upload File
      </CustomFileUploadButton>
      {file && <><span>{fileName}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset>
      <Popup trigger={<SubmitButton type='button'>View File</SubmitButton>} position="right center" modal nested>
        <PopupTable props={file}/>
      </Popup></>}
      <SubmitButton type='submit'>Confirm</SubmitButton>
      </BulkWrapper>
    </form>

    {tabledata.length ? <><TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
      <TableHead  style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow>
          <TableCell>Sl.No. </TableCell>
          <TableCell>Asset </TableCell>
          <TableCell>Order No. </TableCell>
          <TableCell>Store </TableCell>
          <TableCell>ORGTag </TableCell>
          <TableCell>Present OEM Tag </TableCell>
          <TableCell>Modified OEM Tag </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
      {(rowsPerPage > 0
            ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : tabledata
          ).map((row,index) => ( 
            <TableRow key={index}>
              <TableCell  align="left" sx={{ fontSize: 18}}>
                {index + 1}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
                {Object.values(allassets)?.find(x => x.org_tag === row.org_tag)?.name}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
              {addassets[Object.values(allassets)?.find(x => x.org_tag === row.org_tag)?.lot_id]?.orderno || ""}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
              {Object.values(allassets)?.find(x => x.org_tag === row.org_tag)?.cur_store}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
              {row?.org_tag}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
              {Object.values(allassets)?.find(x => x.org_tag === row.org_tag)?.oem_tag}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: 18}}>
              {row?.oem_tag}
              </TableCell>
            </TableRow>
          ))}

      </TableBody>

      <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata? tabledata?.length:[]}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    <CommonButton onClick={onConfirmFinal} disabled={isLoading}>{isLoading? "Loading...":"Confirm ORG Tag Edit"}</CommonButton></>:null}
  
    </>

  )
}

export default OrgToOem
